import { planksBackground } from "./textures";

// The only "chat box" in the game: four lines, fifteen characters each.
export class SignEditor {
  private root = document.getElementById("signedit")!;
  private inputs = [...this.root.querySelectorAll<HTMLInputElement>("input.sl")];
  private cb: ((lines: string[] | null) => void) | null = null;
  onClose: () => void = () => {};

  constructor() {
    document.getElementById("signboard")!.style.backgroundImage = `url(${planksBackground()})`;
    document.getElementById("sign-done")!.addEventListener("click", () => this.close(true));
    document.getElementById("sign-cancel")!.addEventListener("click", () => this.close(false));
    this.inputs.forEach((inp, i) => {
      inp.addEventListener("input", () => {
        inp.value = inp.value.replace(/[^\x20-\x7e]/g, "");
      });
      inp.addEventListener("keydown", (e) => {
        e.stopPropagation();
        if (e.key === "Enter") {
          e.preventDefault();
          if (i < 3) this.inputs[i + 1]!.focus();
          else this.close(true);
        } else if (e.key === "Escape") {
          e.preventDefault();
          this.close(false);
        } else if (e.key === "Backspace" && inp.value === "" && i > 0) {
          e.preventDefault();
          this.inputs[i - 1]!.focus();
        } else if (e.key === "ArrowDown" && i < 3) {
          this.inputs[i + 1]!.focus();
        } else if (e.key === "ArrowUp" && i > 0) {
          this.inputs[i - 1]!.focus();
        }
      });
    });
  }

  get isOpen() {
    return !this.root.hidden;
  }

  open(cb: (lines: string[] | null) => void) {
    this.cb = cb;
    for (const i of this.inputs) i.value = "";
    this.root.hidden = false;
    if (document.pointerLockElement) document.exitPointerLock();
    setTimeout(() => this.inputs[0]!.focus(), 30);
  }

  private close(ok: boolean) {
    if (!this.isOpen) return;
    this.root.hidden = true;
    const lines = this.inputs.map((i) => i.value.slice(0, 15));
    const cb = this.cb;
    this.cb = null;
    cb?.(ok && lines.some((l) => l.trim()) ? lines : null);
    this.onClose();
  }
}
